import { Modal } from 'antd';
import { BaseButton } from 'components/UI/BaseButton';
import PropType from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getMachineType } from 'util/machine-type';
import { TRANSLATION_NAMESPACES } from 'util/translation/constant';
import { unmountPage } from '../../state/action';
import * as selector from '../../state/selector';

export const ModalClaimingSuccess = ({ visible }) => {
  const { t } = useTranslation(TRANSLATION_NAMESPACES.CLAIMING_PROCESS);
  const history = useHistory();
  const dispatch = useDispatch();
  const handleGoSeeMachine = () => {
    if (claimingProcessInfo.newMachine) {
      history.push(`/my-machines/${claimingProcessInfo.newMachine.id}`);
      dispatch(unmountPage());
    }
  };

  const { claimingProcessInfo } = useSelector((state) => ({
    claimingProcessInfo: selector.selectClaimingProcess(state)
  }));

  return (
    <Modal
      maskClosable={false}
      open={visible}
      className="modal-claiming-success"
      footer={[
        <BaseButton
          className="base-yellow-btn"
          data-testid="viewMyMachines"
          onClick={handleGoSeeMachine}>
          {t('claimSuccess.viewButton')}
        </BaseButton>
      ]}>
      <h2 className="bold">{t('claimSuccess.title')}</h2>
      <h5 className="title">
        {t('claimSuccess.description', {
          machineType: getMachineType(
            claimingProcessInfo?.newMachine?.materialNumber
          )
        })}
      </h5>
    </Modal>
  );
};

ModalClaimingSuccess.propTypes = {
  visible: PropType.bool.isRequired
};
